import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { roundByRoundNavSelector } from 'store/modules/brownlow-tracker/round-by-round/selectors/nav-selector';
import { MatchCardVoteFetcher } from './match-card-vote-fetcher';
import { EmptyState } from 'common/react/components/EmptyState';
import { useGetMatchesQuery } from 'common/store/modules/api/afl-api';
import { RoundByRoundSkeleton } from './Leaderboard/components/skeleton-loaders/RoundByRoundSkeleton';

export const RoundByRoundCards = ({ shouldHidePredicted }) => {
    const nav = useSelector(roundByRoundNavSelector);

    const params = {
        competition: nav.competition.id,
        compSeasonId: nav.season.id,
        roundNumber: nav.round,
        matchStatus: PULSE.app.common.CONSTANTS.MATCH_STATUS.CONCLUDED,
        pageSize: 50
    };

    const { data: matches = [], isFetching: isMatchesFetching } =
        useGetMatchesQuery(params);

    return isMatchesFetching ? (
        <div className="brownlow-round-by-round__loader">
            <RoundByRoundSkeleton />
        </div>
    ) : matches.length ? (
        <div className="brownlow-round-by-round__content">
            {matches.map((match) => (
                <MatchCardVoteFetcher
                    key={match.id}
                    matchData={match}
                    seasonPid={nav.season.providerId}
                    seasonId={nav.season.id}
                    modifier="round-by-round"
                    playerModalEnabled={true}
                    shouldHidePredicted={shouldHidePredicted}
                />
            ))}
        </div>
    ) : (
        <div className="brownlow-round-by-round__empty-state">
            <EmptyState
                titleTranslation="label.brownlow.rbr.error.noDataAvailable"
                summaryTranslation="label.brownlow.tracker.error.noDataAvailable.summary"
            />
        </div>
    );
};

RoundByRoundCards.propTypes = {
    shouldHidePredicted: PropTypes.bool
};
